import {fromJust, fromMaybe} from '@freckle/maybe'
import type {MathQuestionMapT} from './../../common/models/questions'
import type {AssessmentAnswerT} from './../models/assessment-answer'

export function getAssessmentAnswersStats(
  asmtAnswers: Array<AssessmentAnswerT>,
  questionMap: MathQuestionMapT
): {
  accuracy: number | undefined | null
  totalWorth: number
  numQAnswered: number
} {
  // Questions with an answer
  const qAnswered = asmtAnswers.filter(
    asmtAnswer => asmtAnswer.answer !== null && asmtAnswer.answer !== undefined
  )

  // Calcute total Worth and student Accuracy
  const stats = qAnswered.reduce(
    (totalObj, qAnswer) => {
      const question = fromJust(
        questionMap.get(qAnswer.questionId),
        `Can't find question ${qAnswer.questionId} for answer ${qAnswer.id}`
      )
      const correctness = fromMaybe(() => 0, qAnswer.correctness)
      return {
        totalAccuracy: totalObj.totalAccuracy + correctness * question.worth,
        totalAssessmentWorth: totalObj.totalAssessmentWorth + question.worth
      }
    },
    {
      totalAccuracy: 0,
      totalAssessmentWorth: 0
    }
  )

  const accuracy =
    stats.totalAssessmentWorth === 0
      ? null
      : Math.round(stats.totalAccuracy / stats.totalAssessmentWorth)

  return {
    accuracy,
    totalWorth: stats.totalAssessmentWorth,
    numQAnswered: qAnswered.length
  }
}
